import { useQuery } from '@tanstack/react-query';

import type { AskMode } from '@/entities/ask-syncly';
import { fetchChatSession } from '@/entities/ask-syncly/api';
import { queryClient } from '@/shared/query-client';

export function useChat({
  queryId,
  workspaceId,
  mode,
}: {
  queryId: string | null;
  workspaceId: string;
  mode: AskMode;
}) {
  return useQuery({
    queryKey: ['chat', workspaceId, queryId, mode],
    queryFn: ({ signal }) => fetchChatSession(workspaceId, queryId!, mode, signal),
    enabled: !!queryId,
  });
}

useChat.refetch = async (workspaceId: string, queryId: string, mode: AskMode) => {
  await queryClient.invalidateQueries({ queryKey: ['chat', workspaceId, queryId, mode] });
};
